import { render, staticRenderFns } from "./record.vue?vue&type=template&id=2e9d46af&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"
import style0 from "./record.vue?vue&type=style&index=0&id=2e9d46af&prod&lang=less"
import style1 from "./record.vue?vue&type=style&index=1&id=2e9d46af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9d46af",
  null
  
)

export default component.exports